import React from "react"
import { Heading, HeadingProps } from "@chakra-ui/react"

import useVideo from "@hooks/useVideo"

const VideoTitle = (props: HeadingProps) => {
  const { video } = useVideo()

  return (
    <Heading as="h4" size="h4" fontWeight="semibold" {...props}>
      {video?.title}
    </Heading>
  )
}

export default VideoTitle
